import createModel, { prop } from './lib/create_model';

export const NO_ANSWER_REFERENCED = 'NO_ANSWER_REFERENCED';

const AnswerPerformance = createModel({
  modelName: 'AnswerPerformance',
  properties: {
    id: prop(String).isRequired,
    name: prop(String).isRequired,
    references: prop(Number).isRequired,
    handoffs: prop(Number).isRequired,
    resolved: prop(Number).isRequired,
    resolutionRate: prop(Number).isRequired,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default AnswerPerformance;
